import React from 'react';

export const DateInput = ({ label, value, onChange, showError }) => {
  return (
    <label className="date-input-label">
      {label}
      <input
        type="date"
        value={value}
        onChange={onChange}
        className={`date-input ${showError && !value ? 'error' : ''}`}
      />
    </label>
  );
};
